export enum RequestStatus {
    None = "None",
    Failed = "Failed",
    Success = "Success",
    Idle = "Idle",
    Loading = "Loading"
}